export default __webpack_public_path__ + "static/img-striped-bass-500x325-f47582944fc71c5e5fcca538e974a565.png";